import { DCSwith_Option } from "../../../data/staticData";
import "./arrTabStyle.css";
import { SECTIONS } from "./section";

const getNestedValue = (obj, path) =>
  path.split(".").reduce((acc, key) => acc?.[key], obj) || "N/A";

const ArrayTable = ({ data, panel }) => {
  const { mppts = [], noOfStrings = 0, noOfMppt = 0, name } = data || {};
  const mpptPerRow = Math.ceil(noOfStrings / noOfMppt) <= 2 ? 4 : 2;

  const chunkedMPPTs = [];
  for (let i = 0; i < mppts.length; i += mpptPerRow) {
    chunkedMPPTs.push(mppts.slice(i, i + mpptPerRow));
  }

  const ocpd = {
    "N/A": { Rating: "N/A", "DC Rating": "N/A", Capacity: "N/A" },
    "Type II": { Rating: "20", "DC Rating": "820", Capacity: "10" },
  };

  return (
    <>
      {chunkedMPPTs.map((chunk, cIdx) => (
        <div className="arr_tab" key={cIdx}>
          {/* === Header === */}
          <div className="arr_tab_sec">
            <div className="ts_head">
              <h5 className="tab_title">{name}</h5>
            </div>
            <div className="mppt-group">
              {chunk.map((mppt, i) => (
                <div className="mppt_tab_container" key={i}>
                  <h5 className="mppt-title">{mppt.name}</h5>
                  <div className="str_box">
                    {mppt.strings?.map((s, j) => (
                      <div className="str_sec" key={j}>
                        <h5 className="str_title">{s.id}</h5>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* === Dynamic Sections === */}
          {SECTIONS.map((section, sIdx) => (
            <div
              className="arr_tab_sec"
              key={sIdx}
              style={
                section.fields[0].fullWidth
                  ? { pageBreakInside: "avoid" }
                  : undefined
              }
            >
              <div className="ts_head">
                <div className="sub_sec">
                  <h3
                    className={`sec_label ${
                      section.fields[0].fullWidth ? "fw_label" : ""
                    }`}
                  >
                    {section.title}
                  </h3>

                  {!section.fields[0].fullWidth && (
                    <div className="sub_sec_labels">
                      {section.fields.map((f, fi) => (
                        <h2
                          className={`ss_label ${f.labelClass || ""}`}
                          key={fi}
                        >
                          {f.label}
                        </h2>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <div className="mppt-group">
                {chunk.map((mppt, mIdx) => (
                  <div className="mppt_tab_container" key={mIdx}>
                    <div className="str_box">
                      {mppt.strings?.map((str) => {
                        const switchData =
                          DCSwith_Option.find(
                            (opt) => opt.label === str.isolator_dc_switch
                          )?.values || {};

                        const type = str.protective_type?.trim() || "N/A";
                        const ocpdData = ocpd[type] || ocpd["N/A"];

                        // build a combined "virtual string"
                        const merged = {
                          ...str,
                          module: panel.name,
                          "Voc(STC)": panel.voc,
                          "Isc(STC)": panel.isc,
                          Rating: ocpdData?.Rating ?? "N/A",
                          "DC Rating": ocpdData?.["DC Rating"] ?? "N/A",
                          Capacity: ocpdData?.Capacity ?? "N/A",

                          "Rating (A)":
                            switchData?.isolator?.["Rating (A)"] ?? "N/A",
                          "Rating (V)":
                            switchData?.isolator?.["Rating (V)"] ?? "N/A",
                        };

                        return (
                          <div className="str_sec">
                            {section.fields.map((f) => (
                              <h4
                                className={`str_sub_info ${
                                  f.key === "module" ? "module_field" : ""
                                }`}
                              >
                                {getNestedValue(merged, f.key)}
                              </h4>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default ArrayTable;
